import { SDLUtil, RequestUtil, StringUtil } from '@/utils';

const setAccountListData = ({ commit }, data) => {
  commit('SET_ACCOUNT_LIST_DATA', data);
};

const setAccountChangesData = ({ commit }, data) => {
  commit('SET_ACCOUNT_CHANGES_DATA', data);
};

export default {
  async SEARCH_ACCOUNT_LIST_DATA(store, param) {
    const data = await RequestUtil.get(`${SDLUtil.API_URL}/accountManagement/accountReport/selectAccountReportList?${StringUtil.queryStringfy(param)}`);
    setAccountListData(store, data.data);
  },
  async SEARCH_ACCOUNT_CHANGES_DATA(store, param) {
    const data = await RequestUtil.get(`${SDLUtil.API_URL}/accountManagement/accountReport/selectAccountChangesList?${StringUtil.queryStringfy(param)}`);
    setAccountChangesData(store, data.data);
  },
};



// WEBPACK FOOTER //
// ./src/vuex/accountManagement/accountReport/accountReportAction.js